export const TYPE_AVATAR = {
  EXPORT: 'export',
  IMPORT: 'import',
  DELETE: 'delete'
}
